(() => {
  'use strict';
  const root = document.getElementById('PierettiDestination');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(root.querySelector('[data-pj-config]').textContent);
  const dialog = root.querySelector('dialog');
  if (!dialog.showModal) return;
  const form = root.querySelector('form');
  const country = form.querySelector('[name="country_code"]');
  const language = form.querySelector('[data-pj-language]');
  const confirm = form.querySelector('[data-pj-confirm]');
  const notice = root.querySelector('[data-pj-notice]');
  const params = new URLSearchParams(location.search);
  const campaignLanguage = (params.get('utm_campaign') || '').match(/(?:^|_)(es|en)(?:_|$)/)?.[1];
  const requestedLanguage = /^\/es(?:\/|$)/.test(location.pathname) ? 'es' : campaignLanguage;
  const testCountry = config.preview ? params.get('pj_test_country')?.toUpperCase() : null;
  const test = /^[A-Z]{2}$/.test(testCountry || '');
  const key = 'pieretti_destination_v1';
  const pendingKey = key + '_pending';
  const attemptKey = key + '_attempt';
  const spanishCountries = new Set(['AR','BO','CL','CO','CR','CU','DO','EC','SV','GQ','GT','HN','MX','NI','PA','PY','PE','PR','ES','UY','VE']);
  const countries = new Set(Array.from(country.options, option => option.value));
  const languages = new Set(Array.from(root.querySelectorAll('[data-pj-lang]'), button => button.dataset.pjLang));
  let selectedLanguage = config.language.startsWith('es') ? 'es' : 'en';
  let unsupported = false;
  let manual = false;
  let previousFocus = null;
  const read = (storage, name) => { try { return JSON.parse(storage.getItem(name)); } catch { return null; } };
  const write = (storage, name, value) => { try { storage.setItem(name, JSON.stringify(value)); } catch {} };
  const remove = (storage, name) => { try { storage.removeItem(name); } catch {} };
  const preferredLanguage = code => spanishCountries.has(code) && languages.has('es') ? 'es' : 'en';
  const saved = test ? null : read(localStorage, key);
  function translate(code) {
    selectedLanguage = languages.has(code) ? code : 'en';
    language.value = selectedLanguage;
    const labels = config.labels[selectedLanguage];
    for (const name of ['title','description','label','confirm','shipping','change']) {
      const node = root.querySelector('[data-pj-' + name + ']');
      if (node) node.textContent = labels[name === 'label' ? 'country' : name];
    }
    dialog.lang = selectedLanguage;
    root.querySelectorAll('[data-pj-lang]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pjLang === selectedLanguage)));
    try {
      const names = new Intl.DisplayNames([selectedLanguage], { type:'region' });
      Array.from(country.options).forEach(option => { option.textContent = names.of(option.value); });
    } catch {}
    notice.hidden = !unsupported;
    notice.textContent = unsupported ? labels.unavailable : '';
  }
  function open() {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    country.focus({ preventScroll:true });
  }
  function close() {
    dialog.close();
    previousFocus?.focus?.({ preventScroll:true });
  }
  dialog.addEventListener('cancel', event => { event.preventDefault(); event.stopImmediatePropagation(); });
  document.addEventListener('keydown', event => {
    if (dialog.open && event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  root.querySelector('[data-pj-reopen]').addEventListener('click', () => {
    manual = true;
    unsupported = false;
    country.value = config.country;
    translate(config.language.startsWith('es') ? 'es' : 'en');
    open();
  });
  root.querySelectorAll('[data-pj-lang]').forEach(button => button.addEventListener('click', () => {
    manual = true;
    translate(button.dataset.pjLang);
  }));
  country.addEventListener('change', () => {
    manual = true;
    unsupported = false;
    translate(preferredLanguage(country.value));
  });
  function prepareReturnTo() {
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = location.pathname + location.search + location.hash;
  }
  prepareReturnTo();
  form.addEventListener('submit', event => {
    if (!countries.has(country.value) || !languages.has(language.value)) { event.preventDefault(); return; }
    const choice = { country:country.value, language:language.value, time:Date.now() };
    if (!test) write(localStorage, key, choice);
    if (test) write(sessionStorage, key + '_test_submitted', true);
    remove(sessionStorage, pendingKey);
    if (country.value === config.country && language.value === config.language) {
      event.preventDefault();
      close();
      return;
    }
    confirm.disabled = true;
  });
  document.addEventListener('submit', event => {
    if (event.target === form || !(event.target instanceof HTMLFormElement)) return;
    const other = event.target;
    if (!other.action.includes('/localization')) return;
    const fd = new FormData(other);
    const c = fd.get('country_code') || config.country;
    const l = fd.get('language_code') || fd.get('locale_code') || config.language;
    if (countries.has(c) && languages.has(l)) write(localStorage, key, { country:c,language:l,time:Date.now() });
  }, true);
  async function detect() {
    if (test) return testCountry;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    try {
      const base = config.root.endsWith('/') ? config.root : config.root + '/';
      const response = await fetch(base + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { signal:controller.signal, credentials:'same-origin' });
      if (!response.ok) return config.country;
      const data = await response.json();
      return data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle || config.country;
    } catch { return config.country; }
    finally { clearTimeout(timeout); }
  }
  async function initialize() {
    translate(selectedLanguage);
    if (test && read(sessionStorage, key + '_test_submitted')) { remove(sessionStorage, key + '_test_submitted'); return; }
    const fresh = saved && Date.now() - saved.time < 180 * 86400000 && countries.has(saved.country) && languages.has(saved.language);
    if (fresh) return;
    const pending = test ? null : read(sessionStorage, pendingKey);
    const detectedCountry = pending?.detectedCountry || await detect();
    if (manual) return;
    const targetLanguage = requestedLanguage || pending?.language || preferredLanguage(detectedCountry);
    unsupported = !countries.has(detectedCountry);
    country.value = unsupported ? config.country : detectedCountry;
    translate(targetLanguage);
    const attempt = test ? read(sessionStorage, attemptKey + '_' + testCountry) : read(sessionStorage, attemptKey);
    if (config.language !== targetLanguage && !attempt) {
      write(sessionStorage, pendingKey, { detectedCountry, language:targetLanguage });
      write(sessionStorage, test ? attemptKey + '_' + testCountry : attemptKey, true);
      language.value = targetLanguage;
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    remove(sessionStorage, pendingKey);
    open();
  }
  initialize();
})();
